import React from 'react';
import Box from "@mui/material/Box";
import Button from 'reactstrap/lib/Button';
import Close from "@xem/icon/qrcode/Close.svg";
import Download from "@xem/icon/qrcode/Download.svg";
import Share from "@xem/icon/qrcode/Share.svg";

import qrtag from '@xem/qr-common/utils/qrtag';
import Base from "@xem/qr-client-react/components/QrView/QrView";
import Col from "@gqlapp/base/Col";

import Row from "@gqlapp/base/Row";
import FormBase from 'reactstrap/lib/Form';
import {saveImg, saveSvg} from "@xem/qr-common";
import {outerHtml} from "@gqlapp/qrcode";

function Header(props){
	let { values, data_text, isQrTag, toDefault, shareFile } = props;
	const { apply, btnSetDefault, append, onClose, handleSubmit, setDefault } = props;
	const [state, setState] = React.useState(false);
	const [error, setError] = React.useState(false);
	let buttons = props?.buttons || [];
	if(isQrTag){
		data_text = qrtag(data_text);
	}

	const data = { url: "https://example.do" }
	
	// debug({ data, data_text, isQrTag });
	
	React.useEffect(function (){
		const allSupported = Object.entries(data).every(([key, value]) => {
			return navigator && navigator.canShare && navigator.canShare({ [key]: value });
		});
		
		if(allSupported){ setState(true); }
	}, [data])
	
	async function onDownload(){
		await saveImg({ filename: 'template', value: 'QR', content: outerHtml(0), width: 300, height: 300, type: 'webp' }).then(() => {} )
	}

	return <>
		{(!!onClose) && <Button onClick={onClose} color={'default'} className={'p-0  modal-close'}
		         style={{ position: 'absolute', right: '10px', top: '8px', zIndex: 1000}}>
			<Close width={24} height={24}/></Button>}
		<>
			<Base
				{...{ values: {...values, data_text}}}
				{...{ viewStyle: { padding: '15px', height: '230px'}}}
				{...{ errorCallback: function errorCallback(error){
					debug({ error })
				}}}
			/>
		</>
		<div className={'position-relative d-flex justify-content-center'}>
			
			<Row className={'d-flex'} medium>
				{(!!toDefault) && <Col xs={'auto'} sx={{'& .btn': { height: '36px', '--btn-light': '#F2F2F2', 'color': '#000000'}}}>
					<Button color={'light'} onClick={setDefault}>{btnSetDefault}</Button></Col>}
				{(!!apply) && <Col xs={'auto'}>
					<FormBase name="create" onSubmit={handleSubmit}>
						<Button
							type={'submit'} className={'border-0'} color={'info'}
							style={{ height: '36px', '--btn-info': '#E7F3FF', 'color': '#0066CC' }}
						>{apply}</Button>
					</FormBase>
				</Col>}
				<Col xs={'auto'}>
					<Button onClick={onDownload} className={'border-0 p-0'} color={'secondary'} style={{'--btn-secondary': '#E7F3FF'}}>
						<Download/>
					</Button>
				</Col>
				{(!!state)&& <Col xs={'auto'} suppressHydrationWarning>
					<Button
						onClick={shareFile('png')}
						className={'border-0 p-0'} color={'secondary'}
						style={{'--btn-secondary': '#E7F3FF'}}>
						<Share/>
					</Button>
				</Col>}
			</Row>
			{(!!error) && <Box className={'error'}>{`qr:qrcode.error`.t()}</Box>}
		</div>
	</>
}

export default Header;